/*
    Author:fanglijuan
    Time:2018-01-04
*/
"use strict";
angular.module("productManageMentBatchDelModule", [])
    .controller("productManageMentBatchDelCtrl", ["$scope", "$modalInstance", "$stateParams", "trsspliceString", "trsHttpService", "delItems", "title",
        function($scope, $modalInstance, $stateParams, trsspliceString, trsHttpService, delItems, title) {
            initData();

            function initData() {
                $scope.title = title;
                $scope.lng = delItems.length;
                $scope.datas = $scope.lng > 2 ? delItems.slice(0, 2) : delItems;
            }
            $scope.cancel = function() {
                $modalInstance.dismiss("cancel");
            };
            $scope.delete = function() {
                $modalInstance.close("success");
            };
        }
    ]);
